// extracted by mini-css-extract-plugin
export var errorsContainer = "_vx-1";
export var link = "_vx-0";